import i18next from 'i18next';

interface Options {
  suffix?: string;
  decimalPoints?: number;
}

const noOptions: Options = {};

export function formatNumber(
  number: number | string,
  { suffix, decimalPoints = 0 }: Options = noOptions
): string {
  if (number === '' || isNaN(Number(number))) return '';

  const localNr = Number(number).toLocaleString(i18next.language === 'en' ? 'en-GB' : 'no-NO', {
    minimumFractionDigits: decimalPoints,
    maximumFractionDigits: decimalPoints,
  });

  return suffix ? `${localNr} ${suffix}` : localNr;
}
